import {
	PHARMACY_ARCHIVED_DELVERIES_LIST_REQUEST,
	PHARMACY_ARCHIVED_DELVERIES_LIST_SUCCESS,
	PHARMACY_ARCHIVED_DELVERIES_LIST_FAILURE
} from '../../../constants';

const initialState = {
	data: null,
	loading: false,
	error: null,
	type: null,
};

const archivedDelveriesListReducer = (state = initialState, action) => {
	switch (action.type) {
		case PHARMACY_ARCHIVED_DELVERIES_LIST_REQUEST:
			return {
				...state,
				loading: action.silent ? state.loading : true,
				data: action.silent ? state.data : null,
				error: null,
				type: action.types,
			};
		case PHARMACY_ARCHIVED_DELVERIES_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				type: action.types,
				error: null,
			};
		case PHARMACY_ARCHIVED_DELVERIES_LIST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				type: action.types,
				data: action.silent ? state.data : null,
			};
		default:
			return state;
	}
};

export default archivedDelveriesListReducer;
